import { Link } from "react-router-dom";

const PageNotFound = () => {
  return (
    <>
      <div className="page">
        <h2 className="display-1 text-center">Page is not available </h2>
        <p className="text-center fw-bold h1 text-danger">
          The Current page is not available
        </p>
        <p className="text-center fw-bold h1 text-danger">
          Click{" "}
          <Link to="/" className="text-primary">
            HERE{" "}
          </Link>{" "}
          to get to the Home page
        </p>
      </div>
    </>
  );
};

export default PageNotFound;
